export default __webpack_public_path__ + "static/media/logo.d65e1f89.svg";